// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import iView from 'iview';
import 'iview/dist/styles/iview.css';
import store from './store/index'
import fun from './assets/js/fun'
import promise from 'es6-promise';
// 富文本编辑器引入
import VueQuillEditor from 'vue-quill-editor'
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import make from './components/make'
Vue.component('make',make)
promise.polyfill();
Vue.config.productionTip = false
Vue.use(iView);
// 富文本编辑器使用
Vue.use(VueQuillEditor)
/* eslint-disable no-new */
import md5 from 'js-md5';
Vue.prototype.$md5 = md5;
Vue.filter("formatetime",function(data){
  if(data){
    return fun.formatetime(data)
  }
  return "****-**-**~**-**-**"
})
Vue.prototype.errorPlus = function (message) {
  this.$Notice.error({title: '错误提示',desc:message});
};
Vue.prototype.loadExcel = function (message, filename) {
  var date = new Date()
  if (window.navigator.msSaveOrOpenBlob) {
    // 兼容ie11
    try {
      var blobObject = new Blob([message])
      window.navigator.msSaveBlob(blobObject, filename + date.getTime() + '.xls')
    } catch (e) {

    }
  } else {
    var blob = new Blob([message], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8'
    }) // application/vnd.openxmlformats-officedocument.spreadsheetml.sheet这里表示xlsx类型
    var downloadElement = document.createElement('a')
    var href = window.URL.createObjectURL(blob) // 创建下载的链接
    downloadElement.href = href
    downloadElement.download = filename + date.getTime() + '.xls' // 下载后文件名
    document.body.appendChild(downloadElement)
    downloadElement.click() // 点击下载
    document.body.removeChild(downloadElement) // 下载完成移除元素
    window.URL.revokeObjectURL(href)
    // 释放掉blob对象
  }
  return Promise.resolve()
}
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js